import type { UploadDto } from '@flowqa/shared';

type DeleteUploadDialogCopy = {
  description: string;
  title: string;
};

export const resolveDeleteUploadDialogCopy = (
  purpose: UploadDto['purpose'] | null | undefined,
): DeleteUploadDialogCopy => {
  if (purpose === 'coverage') {
    return {
      title: 'Delete Coverage Upload',
      description:
        'This coverage upload and its associated coverage files and coverage runs will be deleted.',
    };
  }

  return {
    title: 'Delete Upload',
    description:
      'This upload and its associated results files, execution runs, suite runs and test runs will be deleted.',
  };
};
